import './vendor';
import './utils';
import './services';
import './styles/app.scss';

import Vue from 'vue';
import App from './app';
import store from './store';
import router from './router';

import { translate } from './scripts/core/tools/translate';

translate.init(() =>
    new Vue({
        el: '#app',
        components: { App },
        store,
        router,
        template: '<App/>'
    })
);



// WEBPACK FOOTER //
// ./src/main.js